export default function ConfirmModal({ titulo, mensaje, onConfirmar, onCancelar, colorBoton = '#ef4444', textoBoton = 'Confirmar' }) {
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0,
      width: '100%', height: '100%',
      background: 'rgba(0,0,0,0.6)',
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      zIndex: 300, padding: 16, boxSizing: 'border-box'
    }}>
      <div style={{
        background: '#111', padding: 24, borderRadius: 20,
        width: '100%', maxWidth: 320,
        display: 'flex', flexDirection: 'column', gap: 12,
        textAlign: 'center'
      }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: 'white' }}>{titulo}</div>
        {mensaje && <div style={{ fontSize: 13, color: '#6b7280' }}>{mensaje}</div>}
        <button
          onClick={onConfirmar}
          style={{
            padding: '12px', borderRadius: 10,
            background: colorBoton, color: '#fff',
            border: 'none', cursor: 'pointer',
            fontWeight: 700, fontSize: 14
          }}
        >
          {textoBoton}
        </button>
        <button
          onClick={onCancelar}
          style={{
            padding: '12px', borderRadius: 10,
            background: '#333', color: '#fff',
            border: 'none', cursor: 'pointer', fontWeight: 600
          }}
        >
          Cancelar
        </button>
      </div>
    </div>
  )
}